// PWA home-screen app-icon badge (Badging API). No-op where unsupported.
export function setActivityBadge(count) {
  try {
    if (typeof navigator === "undefined") return;
    if (count > 0 && navigator.setAppBadge) navigator.setAppBadge(count).catch(() => {});
    else if (navigator.clearAppBadge) navigator.clearAppBadge().catch(() => {});
  } catch {
    /* noop */
  }
}
